// Bootstrap

import "bootstrap/js/dist/base-component";
import "bootstrap/js/dist/alert";
import "bootstrap/js/dist/button";
import "bootstrap/js/dist/carousel";
import "bootstrap/js/dist/collapse";
import "bootstrap/js/dist/dropdown";
import "bootstrap/js/dist/modal";
import "bootstrap/js/dist/offcanvas";
import "bootstrap/js/dist/popover";
import "bootstrap/js/dist/scrollspy";
import "bootstrap/js/dist/tab";
import "bootstrap/js/dist/toast";
import "bootstrap/js/dist/tooltip";

// Initialize tooltips and tabs
import { Tooltip, Tab } from 'bootstrap';

// Make Bootstrap available globally for inline scripts
window.bootstrap = { Tooltip, Tab };

var tooltipTriggerList = [].slice.call(
	document.querySelectorAll('[data-bs-toggle="tooltip"]')
);
var tooltipList = tooltipTriggerList.map(function (tooltipTriggerEl) {
	return new Tooltip(tooltipTriggerEl);
});

// Initialize tabs when DOM is loaded
document.addEventListener('DOMContentLoaded', function() {
	console.log('Bootstrap Tab available:', typeof Tab); // Debug log
	console.log('Bootstrap on window:', window.bootstrap); // Debug log

	var tabTriggerList = [].slice.call(
		document.querySelectorAll('[data-bs-toggle="tab"]')
	);
	console.log('Found tabs:', tabTriggerList.length); // Debug log

	if (tabTriggerList.length > 0) {
		tabTriggerList.forEach(function (tabTriggerEl) {
			console.log('Initializing tab:', tabTriggerEl.id); // Debug log
			try {
				var tab = new Tab(tabTriggerEl);
				console.log('Tab initialized successfully:', tab);
			} catch (error) {
				console.error('Error initializing tab:', error);
			}
		});
	} else {
		console.log('No tabs found with data-bs-toggle="tab"');
	}
});

// var popoverTriggerList = [].slice.call(
// 	document.querySelectorAll('[data-bs-toggle="popover"]')
// );
// var popoverList = popoverTriggerList.map(function (popoverTriggerEl) {
// 	return new bootstrap.Popover(popoverTriggerEl);
// });

//NDA acceptance
$(".nda-checkbox input").attr("disabled", true);
$(".nda-checkbox .gfield_checkbox").addClass("disabled");
$(".nda-text").scroll(function(e) {
	if ($(this).scrollTop() + $(this).innerHeight() >= $(this)[0].scrollHeight) {
		$(".nda-checkbox input").removeAttr("disabled");
		$(".nda-checkbox .gfield_checkbox").removeClass("disabled");
	}
});

$(function() {
	$(".nda-checkbox input").click(function() {
		if (
			$(this).prop("disabled") &&
			$(".nda-text").scrollTop() + $(".nda-text").innerHeight() <
				$(".nda-text")[0].scrollHeight
		) {
			// if ($('.nda-text').scrollTop() + $('.nda-text').innerHeight() < $('.nda-text')[0].scrollHeight) {
			$(this).popover({
				container: ".nda-checkbox",
				placement: "bottom",
				content: "Read the NDA and scroll to the bottom to enable"
			});
		}
	});
});

// Login Form Placeholders
$('#user_login').attr('placeholder', 'USERNAME');
// $('#user_email').attr('placeholder', 'User Email');
$('#user_pass').attr('placeholder', 'PASSWORD');

// Custom
import initNavbarScroll from './navbarScroll';
import initFancybox from './fancybox';
import initGsap from './gsap';
import initSwiper from './swiper';

// Initialize Functionality
initFancybox();
initNavbarScroll();
initGsap();
initSwiper();
